export const TOKEN_EXPIRED = 'token_expired';
export const TOGGLE_MAP = 'toggle_map_seo';
export const SEO_FILTERS_OPEN = 'seo_filters_open';
export const SEO_FILTERS_CLOSE = 'seo_filters_close';

